var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user__image"},[(_vm.image)?_c('b-img',{staticClass:"rounded-circle",attrs:{"src":_vm.image}}):_c('b-img',{staticClass:"rounded-circle",attrs:{"src":require("@/assets/images/no-user.jpg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }